import React from 'react';
import './CalendarEventList.css';

// Events as the calendar routes return them (Google or iPhone shape): { id, summary, location, start: {dateTime|date}, end }.
const TIME_OPTIONS = { hour: 'numeric', minute: '2-digit' };

function timeLabel(event) {
  if (event.start?.date && !event.start?.dateTime) return 'All day';
  const start = new Date(event.start?.dateTime);
  const end = new Date(event.end?.dateTime);
  if (isNaN(start)) return '';
  const from = start.toLocaleTimeString([], TIME_OPTIONS);
  return isNaN(end) ? from : `${from} – ${end.toLocaleTimeString([], TIME_OPTIONS)}`;
}

const CalendarEventList = ({ events, emptyText = 'Nothing in the calendar for this date', syncedAt }) => {
  const list = events || [];
  return (
    <div className="cel">
      {list.length === 0 ? (
        <div className="cel-empty">{emptyText}</div>
      ) : (
        <ul className="cel-list">
          {list.map((event, i) => (
            <li key={event.id || i} className="cel-item">
              <div className="cel-time">{timeLabel(event)}</div>
              <div className="cel-main">
                <div className="cel-title">{event.summary || '(No title)'}</div>
                {event.location && <div className="cel-sub">📍 {event.location}</div>}
                {event.calendarTitle && <div className="cel-sub">{event.calendarTitle}</div>}
              </div>
            </li>
          ))}
        </ul>
      )}
      {syncedAt && (
        <div className="cel-synced">Updated from the coach's iPhone {new Date(syncedAt).toLocaleString([], { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' })}</div>
      )}
    </div>
  );
};

export default CalendarEventList;
